export default IconArrowsDiagonalMinimize2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrows-diagonal-minimize-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18 10h-4v-4" />
  <path d="M20 4l-6 6" />
  <path d="M6 14h4v4" />
  <path d="M10 14l-6 6" />
</svg>`;